import logo from './logo.svg';
import './App.css';
import React from 'react';
import ReactDOM from 'react-dom';
import * as echarts from 'echarts';

const DAYS_PER_YEAR = 365.25;
const SECONDS_PER_YEAR = DAYS_PER_YEAR * 24 * 60 * 60;

/**
 * Formula source: http://www.linked8.com/blog/158-apy-to-apr-and-apr-to-apy-calculation-methodologies
 *
 * @param interest {Number} APR as percentage (ie. 5.82)
 * @param frequency {Number} Compounding frequency (times a year)
 * @returns {Number} APY as percentage (ie. 6 for APR of 5.82%)
 */
const aprToApy = function (money, apr, count, cost) {
  if (money === 0) {
    return 0;
  }
  if (apr === 0) {
    return 0;
  }
  var rate_per_count = apr / 100 / (count + 1);
  var new_money = money;
  for (var i=0;i<=count;i++) { 
    new_money = new_money + rate_per_count * new_money - cost;
  }
  return (new_money + cost - money) / money * 100;
}

class HelloMessage extends React.Component {
  constructor(props) {
      super(props);
      this.state = {money: 100, apr: 100, count: 0, cost: 0, apy: 0, graph_data: []};
      this.handleMoneyChange = this.handleMoneyChange.bind(this);
      this.handleAprChange = this.handleAprChange.bind(this);
      this.handleCountChange = this.handleCountChange.bind(this);
      this.handleCostChange = this.handleCostChange.bind(this);
      this.handleButtonClick = this.handleButtonClick.bind(this);
  }
  componentDidMount() {
    var myChart = echarts.init(document.getElementById('forms'));
    this.state.graph_data = [
            {
              name: "点数据",
              value: [
                  0,
                  0
              ]
            }
          ];
    myChart.setOption({
      tooltip: {
          trigger: 'axis',
          formatter: function (params) {
              params = params[0];
              return '复投次数:' + params.value[0] + ' - APY:' + params.value[1].toFixed(2);
          },
          axisPointer: {
              animation: false
          }
      },
      xAxis: {
          type: 'value',
          splitLine: {
              show: true
          }
      },
      yAxis: {
          type: 'value',
          splitLine: {
              show: true
          }
      },
      series: [{
          name: '图数据',
          type: 'line',
          showSymbol: false,
          hoverAnimation: false,
          data: this.state.graph_data
      }]
    });
  }
  handleMoneyChange(event) {
    this.setState({money: event.target.value});
  }
  handleAprChange(event) {
    this.setState({apr: event.target.value});
  }
  handleCountChange(event) {
    this.setState({count: event.target.value});
  }
  handleCostChange(event) {
    this.setState({cost: event.target.value});
  }
  handleButtonClick(event) {
    this.state.graph_data = [
            {
              name: "点数据",
              value: [
                  0,
                  0
              ]
            }
          ];

    var cost = Number(this.state.cost);
    if (cost<=0) {
      alert("复投成本为0，所以复投次数越大越好！");
      return;
    }
    var myChart = echarts.init(document.getElementById('forms'));
    var money = Number(this.state.money);
    var apr = Number(this.state.apr);
    
    var lastAPY = 0;
    var rightCount = -1;
    for (var count=1;count<=525960;count++) { 
      var newAPY = aprToApy(money,apr,count,cost);
      if (newAPY<lastAPY) {
        if (rightCount === -1) {
          this.setState({count: count - 1});
          rightCount = count;
          console.log(rightCount);
        } else if (rightCount === 0) {
          console.log(rightCount);
          console.log('break');
          break;
        }
        rightCount = rightCount - 1;
        console.log(rightCount);
      } // else {
        // if(this.state.graph_data.length > 1000) {
          // this.state.graph_data.shift();
        // }
        this.state.graph_data.push({
              name: "点数据",
              value: [
                  count,
                  newAPY
              ]
            });
      // }
      lastAPY = newAPY;
    }
    myChart.setOption({
        series: [{
            data: this.state.graph_data
        }]
    });
  }
  render() {
    var money = Number(this.state.money);
    var apr = Number(this.state.apr);
    var count = Number(this.state.count);
    var cost = Number(this.state.cost);
    var apy = aprToApy(money, apr, count, cost);
    return <div>
              <div>
                本金
                <input type="number" min="0" placeholder="Money" value={money} onChange={this.handleMoneyChange} />
                APR(%)
                <input type="number" min="0" placeholder="APR(%)" value={apr} onChange={this.handleAprChange} />
                复投花费
                <input type="number" min="0" placeholder="Cost of Each Compound" value={cost} onChange={this.handleCostChange} />
                复投次数
                <input type="number" step="1" min="0" max="1000000" placeholder="Compound Count" value={count} onChange={this.handleCountChange} />
                APY: {apy.toFixed(2)}%
              </div>
              <button onClick={this.handleButtonClick}>
                {'自动寻找最佳复投次数'}
              </button>
              <div id="forms" style={{width:'100%',height:'350px'}}></div>
           </div>;
  }
}

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>
          Convert APR to APY
        </p>
        <HelloMessage />
      </header>
    </div>
  );
}

export default App;
